<template>
  <div>
    <div :class="{ 'fixed': showIntentsTable }">
      <nav-bar></nav-bar>
      <div class="boxes-container section pt-1 pl-1 pr-1">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('ANALYTICS_BREADCRUMB') +' / ' + clientName }}</a></li>
        </nav>
        <div class="date-picker">
          <div class="column" v-for="(option, index) in datePickerOptions" :key="index"
            :class="{ 'first': index === 0, 'last': index === (datePickerOptions.length - 1), 'selected': index === dateOptionSelected,
              'disabled': !data}"
            @click="changeDateOption(index)">
            {{ option }}
          </div>
          <div class="update-query" @click="getAnalyticsData()"><span class="icon"><i class="fas fa-redo"></i></span></div>
        </div>
        <Statistics :data="data"></Statistics>
      </div>
      <Charts :content="data" v-on:showIntentsTableView="showIntentsTableView" v-on:showKpiAgentsView="toggleKpiAgentsView"></Charts>
      <div class="section pt-4 has-text-centered" v-if="!data">{{ CONSTANTS.getCopy('ANALYTICS_LOADING') }}</div>
    </div>
    <AnalyticsIntentsTableVue v-if="showIntentsTable" @closeTableView="closeIntentsTable" :data="intentsTableData"
      :type="typeIntentTable" :client="client"/>
    <KpiAgents v-if="showKpiAgents" v-on:closeView="toggleKpiAgentsView" :client="client" :typeSearch="dateOptionSelected" :interval="datePickerOptions[dateOptionSelected]"/>
  </div>
</template>

<script>

import AnalyticsIntentsTableVue from './AnalyticsIntentsTable'
import Statistics from './Statistics'
import Charts from './Charts'
import KpiAgents from './KpiAgents'
import CONSTANTS from '../../constants'

export default {
  components: { AnalyticsIntentsTableVue, Statistics, Charts, KpiAgents },
  data () {
    return {
      datePickerOptions: [
        CONSTANTS.getCopy('ANALYTICS_TOTAL'),
        CONSTANTS.getCopy('ANALYTICS_LAST_YEAR'),
        CONSTANTS.getCopy('ANALYTICS_THIS_YEAR'),
        CONSTANTS.getCopy('ANALYTICS_LAST_MONTH'),
        CONSTANTS.getCopy('ANALYTICS_THIS_MONTH'),
        CONSTANTS.getCopy('ANALYTICS_LAST_7_DAYS'),
        CONSTANTS.getCopy('ANALYTICS_TODAY')
      ],
      dateOptionSelected: 4,
      client: this.$route.params.client,
      clientName: CONSTANTS.getCopy('ANALYTICS_ALL_CLIENTS'),
      data: null,
      showIntentsTable: false,
      showKpiAgents: false,
      intentsTableData: null,
      typeIntentTable: 1
    }
  },
  created () {
    this.breadcrumbDetails()
    this.getAnalyticsData()
  },
  methods: {
    breadcrumbDetails () {
      if (this.client) {
        this.api.post('/ClientById/', { idClient: this.client }).then(response => {
          this.clientName = response.client.name
        })
      }
    },
    getAnalyticsData () {
      this.api.post('/Analitics/', { typeSearch: this.dateOptionSelected + 1, idClient: this.client })
        .then(response => {
          this.data = response
        })
    },
    changeDateOption (index) {
      this.dateOptionSelected = index
      this.data = null
      this.getAnalyticsData()
    },
    showIntentsTableView (type) {
      this.api.post('/Analitics_Intents/', { typeSearch: this.dateOptionSelected + 1, idClient: this.client })
        .then(response => {
          this.intentsTableData = response
        })
      this.showIntentsTable = true
      this.typeIntentTable = type
    },
    toggleKpiAgentsView () {
      this.showKpiAgents = !this.showKpiAgents
    },
    closeIntentsTable () {
      this.showIntentsTable = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Analytics/Analytics.vue